import { seasonsApi } from "./seasonsApi";

let url = require('url');

export default class apiPaths {
    private static basePaths = {
        media: {
            reportsAPIPath: "/api/v2/Reports/",
            matchesAPIPath: "/api/Matches/",
            reportResultsAPIPath: "/api/ReportResults/",
            teamsAPIPath: "/api/Teams/",
            seasonsAPIPath: "/api/Seasons/",
            seriesAPIPath: "/api/Series/",
        },
        reports: {
            eventCodesAPIPath: "/api/EventCodes/",
            reportsAPIPath: "/api/Reports/"
        }
    }

    constructor() { }

    public static GetSeriesList(playerId: string) {
        return url.resolve(this.basePaths.media.seriesAPIPath, `GetSeriesList?playerId=${playerId}`);
    }

    public static GetSeasonsForSeries(seriesId: string) {
        return url.resolve(this.basePaths.media.seasonsAPIPath, `GetSeasonsForSeries?seriesGuid=${seriesId}`);
    }

    public static GetTeamsForMatch(matchId: string) {
        return url.resolve(this.basePaths.media.teamsAPIPath, `GetTeamsForMatch?matchId=${matchId}`);
    }

    public static getPlaylistForPlayerMetric(userId: string, reportId: string, matchId: string, teamId: string, metricId: string, clipName: string, playerId: string) {
        return url.resolve(this.basePaths.media.reportResultsAPIPath, `GetPlaylistForPlayerMetric?clientId=${userId}&reportId=${reportId}&matchSeasonId=${matchId}&teamId=${teamId}&playerId=${playerId}&metricId=${metricId}&clipName=${clipName}`);
    }

    public static getPlaylistForTeamMetric(userId: string, reportId: string, matchId: string, teamId: string, metricId: string, clipName: string) {
        return url.resolve(this.basePaths.media.reportResultsAPIPath, `GetPlaylistForTeamMetric?clientId=${userId}&reportId=${reportId}&matchSeasonId=${matchId}&teamId=${teamId}&metricId=${metricId}&clipName=${clipName}`);
    }

    public static getEventCode(eventCodeGuid: string) {
        return url.resolve(this.basePaths.reports.eventCodesAPIPath, `GetEventCode?eventCodeGuid=${eventCodeGuid}`);
    }

    public static getEventCodes(eventCodeSetGuid: string) {
        return url.resolve(this.basePaths.reports.eventCodesAPIPath, `GetEventCodes?eventCodeSetGuid=${eventCodeSetGuid}`);
    }

    public static getEventCodeSet(eventCodeSetGuid: string) {
        return url.resolve(this.basePaths.reports.eventCodesAPIPath, `GetEventCodeSet?eventCodeSetGuid=${eventCodeSetGuid}`);
    }

    public static getEventCodeSets(userGuid: string) {
        return url.resolve(this.basePaths.reports.eventCodesAPIPath, `GetEventCodeSets?userGuid=${userGuid}`);
    }

    public static getEventItemTypeOption(eventItemTypeOptionGuid: string) {
        return url.resolve(this.basePaths.reports.eventCodesAPIPath, `GetEventItemTypeOption?eventItemTypeOption=${eventItemTypeOptionGuid}`);
    }

    public static getEventItemTypeOptions(eventCodeSetGuid: string) {
        return url.resolve(this.basePaths.reports.eventCodesAPIPath, `GetEventItemTypeOptions?eventCodeSetGuid=${eventCodeSetGuid}`);
    }

    // Media Report Paths

    public static getTemplateFromMedia(userId: string, templateId: string) {
        return url.resolve(this.basePaths.media.reportsAPIPath, `GetReportTemplate?userId=${userId}&reportTemplateId=${templateId}`);
    }    

    public static getTemplatesFromMedia(userId: string) {
        return url.resolve(this.basePaths.media.reportsAPIPath, `GetReportTemplates?userId=${userId}`);
    }    

    public static getReportConfigsFromMedia(userId: string) {
        return url.resolve(this.basePaths.media.reportsAPIPath, `GetReportConfigs?userId=${userId}`);
    }    

    public static getReportFiltersFromMedia(userId: string) {
        return url.resolve(this.basePaths.media.reportsAPIPath, `GetReportFilters?userId=${userId}`);
    }    

    public static getTemplatesByConfigFromMedia(userId: string, reportId: string) {
        return url.resolve(this.basePaths.media.reportsAPIPath, `GetReportTemplatesByConfig?userId=${userId}&reportId=${reportId}`);
    }

    public static getTemplatesByReportTypeFromMedia(userId: string, reportType: number) {
        return url.resolve(this.basePaths.media.reportsAPIPath, `GetReportTemplatesByReportType?userId=${userId}&reportType=${reportType}`);
    }

    // Reports Paths

    public static postReportTemplate(userId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `PostReportTemplate?userId=${userId}`);
    }

    public static postReportConfig(userId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `PostReportConfig?userId=${userId}`);
    }

    public static postReportFilter(userId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `PostReportFilter?userId=${userId}`);
    }

    public static getReportTemplates(userId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportTemplates?userId=${userId}`);
    }

    public static getReportConfigs(userId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportConfigs?userId=${userId}`);
    }

    public static getReportConfig(userId: string, reportId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportConfig?userId=${userId}&reportId=${reportId}`);
    }

    public static getReportFilters(userId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportFilters?userId=${userId}`);
    }

    public static getReportFilter(userId: string, reportFilterId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportFilter?userId=${userId}&reportFilterId=${reportFilterId}`);
    }

    public static getTemplateFromReports(userId: string, templateId: string) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportTemplate?userId=${userId}&reportTemplateId=${templateId}`);
    }

    public static getTemplatesByReportTypeFromReports(userId: string, reportType: number) {
        return url.resolve(this.basePaths.reports.reportsAPIPath, `GetReportTemplatesByReportType?userId=${userId}&reportType=${reportType}`);
    }

    public static GetScoreSummaryForMatch(matchId: string) {
        return url.resolve(this.basePaths.media.matchesAPIPath, `GetScoreSummaryForMatch?matchId=${matchId}`);
    }

    public static searchPreviousMatches(searchTeamOneId: string, searchTeamTwoId: string, seriesId: string, seasonId: string, pageSize: number, pageNumber: number) {
        return url.resolve(this.basePaths.media.matchesAPIPath, `SearchPreviousMatches?searchTeamOneId=${searchTeamOneId}&searchTeamTwoId=${searchTeamTwoId}&seriesId=${seriesId}&seasonId=${seasonId}&pageSize=${pageSize}&pageNumber=${pageNumber}`);
    }

    public static GetTeamMatchReport(reportId: string, matchId: string, teamId: string, reportFilterId: string) {
        if (!reportFilterId)
            reportFilterId = "";

        return url.resolve(this.basePaths.media.reportsAPIPath, `GetTeamMatchReport?reportId=${reportId}&matchId=${matchId}&teamId=${teamId}&reportFilterId=${reportFilterId}`);
    }

    public static GetPlayerMatchReport(reportId: string, matchId: string, playerId: string, teamId: string, reportFilterId: string) {
        if (!playerId)
            playerId = "";

        if (!teamId)
            teamId = "";

        if (!reportFilterId)
            reportFilterId = "";

        return url.resolve(this.basePaths.media.reportsAPIPath, `GetPlayerMatchReport?reportId=${reportId}&matchId=${matchId}&playerId=${playerId}&teamId=${teamId}&reportFilterId=${reportFilterId}`);
    }

    public static GetTeamSeasonReport(reportId: string, seasonId: string, teamId: string, reportFilterId: string) {
        if (!teamId)
            teamId = "";

        if (!reportFilterId)
            reportFilterId = "";

        return url.resolve(this.basePaths.media.reportsAPIPath, `GetTeamSeasonReport?reportId=${reportId}&seasonId=${seasonId}&teamId=${teamId}&reportFilterId=${reportFilterId}`);
    }

    public static GetPlayerSeasonReport(reportId: string, seasonId: string, playerId: string, teamId: string, reportFilterId: string) {
        if (!playerId)
            playerId = "";

        if (!teamId)
            teamId = "";

        if (!reportFilterId)
            reportFilterId = "";

        return url.resolve(this.basePaths.media.reportsAPIPath, `GetPlayerSeasonReport?reportId=${reportId}&seasonId=${seasonId}&playerId=${playerId}&teamId=${teamId}&reportFilterId=${reportFilterId}`);
    }

    public static GetTeamSeriesReport(reportId: string, seriesId: string, teamId: string, reportFilterId: string) {
        if (!teamId)
            teamId = "";

        if (!reportFilterId)
            reportFilterId = "";

        return url.resolve(this.basePaths.media.reportsAPIPath, `GetTeamSeriesReport?reportId=${reportId}&seriesId=${seriesId}&teamId=${teamId}&reportFilterId=${reportFilterId}`);
    }

    public static GetPlayerSeriesReport(reportId: string, seriesId: string, playerId: string, teamId: string, reportFilterId: string) {
        if (!playerId)
            playerId = "";

        if (!teamId)
            teamId = "";

        if (!reportFilterId)
            reportFilterId = "";

        return url.resolve(this.basePaths.media.reportsAPIPath, `GetPlayerSeriesReport?reportId=${reportId}&seriesId=${seriesId}&playerId=${playerId}&teamId=${teamId}&reportFilterId=${reportFilterId}`);
    }
}